import $ from 'jquery'

export function scrollToElement(selector, t, verticalOff) {
  const time = typeof (t) !== 'undefined' ? t : 1000
  const verticalOffset = typeof (verticalOff) !== 'undefined' ? verticalOff : 0
  const element = $(selector)
  const offset = element.offset()
  const offsetTop = offset.top + verticalOffset
  $('html, body').animate({
    scrollTop: offsetTop
  }, time)
}



// WEBPACK FOOTER //
// ./app/utils/helper.js